export class PropertyValueType {
  public static readonly INT: string = 'INT';
  public static readonly FLOAT: string = 'FLOAT';
  public static readonly STRING: string = 'STRING';
  public static readonly INTRANGE: string = 'INTRANGE';
  public static readonly FLOATRANGE: string = 'FLOATRANGE';
  public static readonly OBJECT: string = 'OBJECT';
}
